import React, { useState, useEffect } from "react";
import { FaShareAlt } from "react-icons/fa";
import ShareModal from "../ShareModal/ShareModal";
import { trackLandingVisitApi } from "../../utils/shareTracking";
import "./ShareEventButton.css";

const ShareEventButton = ({ event }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const resolvedEvent = {
    id: event?.id || event?.slug || "event",
    slug: event?.slug || "event",
    title: event?.title || document.title.split("|")[0].trim() || "Event",
    path: event?.slug
      ? `/events/eventdetail/${event.slug}`
      : typeof window !== "undefined"
      ? window.location.pathname
      : "",
    category: event?.category || "Event & Session",
    contentType: "event"
  };

  // Track landing visit on page load if UTM query parameters exist
  useEffect(() => {
    if (typeof window !== "undefined" && window.location.search) {
      trackLandingVisitApi({
        contentType: "event",
        eventId: resolvedEvent.id,
        eventTitle: resolvedEvent.title,
        eventPath: resolvedEvent.path,
        projectId: resolvedEvent.id,
        projectTitle: resolvedEvent.title,
        projectPath: resolvedEvent.path
      });
    }
  }, [resolvedEvent.id, resolvedEvent.title, resolvedEvent.path]);

  return (
    <div className="share-event-wrapper">
      <button
        type="button"
        className="share-event-btn"
        onClick={() => setIsModalOpen(true)}
        aria-label={`Share ${resolvedEvent.title}`}
        title="Share Event"
      >
        <span className="share-btn-icon">
          <FaShareAlt />
        </span>
        <span className="share-btn-text">Share This Event</span>
      </button>

      <ShareModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        item={resolvedEvent}
        contentType="event"
      />
    </div>
  );
};

export default ShareEventButton;
